import { render, staticRenderFns } from "./BillBatchReportComponent.vue?vue&type=template&id=08a63c45&"
import script from "./BillBatchReportComponent.vue?vue&type=script&lang=js&"
export * from "./BillBatchReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports